// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"5c86f93b","488":"c9e6479c","592":"8e13fd56","663":"48ce4b64","684":"44fa3d8c","790":"96cb4922","798":"cf3de938","861":"8a6c53d2","864":"66da8a75"}[chunkId] + ".chunk.js";
};